import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { Hero } from "@/components/site/Hero";
import { PageShell } from "@/components/site/PageShell";
import { SERVICES } from "@/data/services";

export default function NotFoundPage() {
  return (
    <>
      <Seo title="Seite nicht gefunden | Kfz-Gutachter Marcone" description="Die gesuchte Seite existiert nicht. Hier finden Sie alle Leistungen des Kfz-Sachverständigen Marcone in Köln." noindex />
      <PageShell hero={<Hero image="hero-gebrauchtwagen" imageAlt="Fahrzeug auf der Hebebühne in einer Werkstatt" eyebrow="Fehler 404" title="Seite nicht gefunden" subtitle="Diese Seite gibt es leider nicht (mehr). Aber wir helfen Ihnen trotzdem gern weiter." badges={false} />}>
        <div data-testid="not-found-page">
          <h2 className="h2-brand text-2xl sm:text-3xl">Vielleicht suchen Sie …</h2>
          <ul className="mt-6 grid gap-3 sm:grid-cols-2">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/${s.slug}`} className="flex items-center justify-between rounded-2xl border border-slate-200 p-4 font-semibold text-brand-anthracite transition-colors hover:border-brand-blue hover:text-brand-blue" data-testid={`not-found-link-${s.slug}`}>
                  {s.name} <ArrowRight className="h-4 w-4" />
                </Link>
              </li>
            ))}
            <li>
              <Link to="/" className="flex items-center justify-between rounded-2xl bg-brand-blue p-4 font-semibold text-white" data-testid="not-found-home-link">
                Zur Startseite <ArrowRight className="h-4 w-4" />
              </Link>
            </li>
          </ul>
          <p className="mt-8 text-[15px]">Oder nutzen Sie direkt das Formular – wir melden uns meist innerhalb von 30 Minuten.</p>
        </div>
      </PageShell>
    </>
  );
}
